import { useApiClient } from '@/hooks/useApiClient'
import { useMemo } from 'react'
import { ConflictDependentSelect, type ConflictSelectProps } from './ConflictDependentSelect'

export function ScheduleItemTractorSelect(props: ConflictSelectProps) {
  const api = useApiClient()
  const { data, isLoading } = api.useQuery('post', '/tractor/all')
  const tractors = useMemo(() => data?.map((x) => ({ id: x.id, name: x.tractor_number, depot: x.depot })) ?? [], [data])
  return (
    <ConflictDependentSelect label='Tractor' {...props} items={tractors} loading={isLoading} itemKey='tractor_id' />
  )
}
